@if (showDevComments) {
  <div class="dev-comment">src\app\shared-components\cancel-reason-select\cancel-reason-select.component.html</div>
}

<div class="form-group">
  <label for="sel1">Reason</label>
  <select class="form-control" (change)="onChange($event)" [(ngModel)]="selectedReason"   >
    @for (r of reasons; track r) {
      <option [value]="r">{{ r.name }}</option>
    }
  </select>
</div>

